import { render, staticRenderFns } from "./WoundMeasurements.vue?vue&type=template&id=e9348f76&"
import script from "./WoundMeasurements.vue?vue&type=script&lang=js&"
export * from "./WoundMeasurements.vue?vue&type=script&lang=js&"
import style0 from "./WoundMeasurements.vue?vue&type=style&index=0&id=e9348f76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports